import { Button, Flex, Link } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { NavBarItem } from 'interfaces/layout/nav-bar';

const NavBarTrigger = (props: { item: NavBarItem }) => {
  const btn = (
    <Button
      className="btn-floating"
      variant="soft"
      color={props.item.color}
      onClick={props.item.onClick}
    >
      {props.item.label}
    </Button>
  );

  if (props.item.href) {
    return <Link href={props.item.href}>{btn}</Link>;
  }

  return btn;
};

export const NavBar = (props: { start?: NavBarItem[]; end?: NavBarItem[] }) => {
  return (
    <EB>
      <Flex justify="between" style={{ width: '100%' }}>
        {props.start && (
          <Flex align="center">
            {props.start.map((item, i) => (
              <NavBarTrigger key={`i-${i}`} item={item} />
            ))}
          </Flex>
        )}
        {props.end && (
          <Flex align="center">
            {props.end.map((item, i) => (
              <NavBarTrigger key={`i-${i}`} item={item} />
            ))}
          </Flex>
        )}
      </Flex>
    </EB>
  );
};
